import { useState } from 'react';
import { CiLogin } from 'react-icons/ci';
import { useTranslation } from 'react-i18next';
import { renderIcon } from '@/utils/iconRenderer';

const AcountLoginForm = ({ onSubmit, requestPending }) => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const { t } = useTranslation();

  const isSubmit = userName.trim() && password.trim();

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(userName, password); // login işlemi üst bileşende yapılacak
  };

  return (
    <form onSubmit={handleSubmit} className="p-2 border-b-2  text-sm">
      <div className="flex items-center border rounded-md overflow-hidden my-2 mx-2 gap-0 p-0">
        <span className="text-black p-1">
          {renderIcon('user', 20, 'text-color-text-gray')}
        </span>

        <input
          className="flex-1 p-1 text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary"
          id="username"
          type="text"
          placeholder={t('UserCode')}
          value={userName}
          autoComplete="current-password"
          onChange={(e) => setUserName(e.target.value)}
        />
      </div>
      <div className="flex items-center border rounded-md overflow-hidden my-2 mx-2 gap-0 p-0">
        <span className="text-black  p-1">
          {renderIcon('lock-password-line', 20, 'text-color-text-gray')}
        </span>

        <input
          className="flex-1 p-1 text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary"
          id="password"
          type="password"
          placeholder={t('Sifre')}
          value={password}
          autoComplete="current-password"
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <div className="flex justify-center my-2">
        <button
          className={`flex items-center px-10 py-2 bg-color-button text-white rounded-md shadow-md hover:bg-color-button-hover transition-colors ${
            !isSubmit || requestPending ? 'cursor-not-allowed' : ''
          }`}
          type="submit"
          disabled={!isSubmit || requestPending}>
          <CiLogin size={28} className="inline-block mr-2" />
          <p className="m-0">{t('Giris')}</p>
        </button>
      </div>
    </form>
  );
};

export default AcountLoginForm;
